<template>
    <div id="exp_result">
        <h1>{{$route.params.id}} experiment detail info</h1>
        <div v-if="this.ann !== null">
            <h2>{{instrument_model}}; {{sample_title}}; {{scientific_name}}; {{library_strategy}}</h2>


                <b-row>
                    <b-col cols="8">
<!--Здесь будет основная информация-->
                        <div>
                            <h3 id="summary" style="margin-top: 25px;">Summary</h3>

                            <p>Study: <router-link :to="`/study/${study_link}`">{{study_title}}</router-link></p>
                            <p>Library source: {{library_source}}</p>
                            <p>Library selection: {{library_selection}}</p>
                            <p>Tissue type: {{tissue_type}}</p>
                            <p>Library layout: {{library_layout}}</p>
                            <p>Run accessions: {{run_accessions_formated}}</p>
                            <p>Construction protocol: {{construction_protocol}}</p>

                            <h3 id="denovo" style="margin-top: 25px;">De novo transcriptome assembly</h3>

                            <p>Reads number: {{reads_number}}</p>
                            <p>KMERs: {{KMERs}}</p>
                            <p>Input size: {{in_size}}</p>
                            <p>Output size: {{out_size}}</p>
                            <p>Transcripts: {{transcripts}}</p>
                            <p>Transcripts > 500 bp: {{transcripts_500}}</p>
                            <p>Transcripts > 1000 bp: {{transcripts_1000}}</p>
                            <p>Average length of assembled transcripts: {{ave_length}}</p>
                            <p>Longest transcript: {{longest_transcript}}</p>
                            <p>Total length: {{total_length}}</p>
                            <p>Transcript N50: {{transcript_n50}}</p>
                            <p>Triniry version: {{trinity_version}}</p>

                            <h3 id="aligning" style="margin-top: 25px;" >Aligning to a reference genome</h3>

                            <b-btn variant="link" v-b-toggle.ref-genome-collaps style="padding-left: 0; border-left: 0;">
                                <p class="h5">Reference genome info</p>
                            </b-btn>
                            <b-collapse id="ref-genome-collaps">
                                <b-card style="margin-bottom: 10px;">
                                    <p>Genome name: {{genome_name}}</p>
                                    <p>Genes: {{genes}}</p>
                                    <p>Isoforms: {{isoforms}}</p>
                                    <p>Protein coding isoforms: {{protein_coding_genes}}</p>
                                    <p>Exons: {{exons}}</p>
                                    <p>Introns: {{introns}}</p>
                                    <p>Avg. length of all isoforms: {{avg_length_of_all_isoforms}}</p>
                                    <p>Total length of all isoforms: {{total_length_of_all_isoforms}}</p>
                                    <p>Avg. exon length: {{avg_exon_length}}</p>
                                    <p>Avg. intron length: {{avg_intron_length}}</p>
                                    <p>Avg. number of exons per isoform: {{avg_number_of_exons_per_isoform}}</p>
                                    <p>Max. number of exons per isoform: {{max_number_of_exons_per_isoform}}</p>
                                </b-card>

                            </b-collapse>



                            <h5>Alignment metrics</h5>

                            <p>Transcripts: {{transcripts_percent}}</p>
                            <p>Aligned: {{aligned}}</p>
                            <p>Uniquely aligned: {{uniquely_aligned}}</p>
                            <p>Multiply aligned: {{multiply_aligned}}</p>
                            <p>Misassembly candidates reported by GMAP: {{misassembly_candidates}}</p>
                            <p>Unaligned: {{unaligned}}</p>
                            <p>Unannotated: {{unannotated}}</p>


                            <h5>Alignment metrics for non-misassembled transcripts</h5>
                            <p>Average aligned fraction: {{average_aligned_fraction}}</p>
                            <p>Average alignment length: {{average_alignment_length}}</p>
                            <p>Average blocks per alignment: {{average_blocks_per_alignment}}</p>
                            <p>Average block length: {{average_block_length}}</p>
                            <p>Average mismatches per transcript: {{average_mismatches_per_transcript}}</p>
                            <p>NA50: {{na50}}</p>



                            <h3 id="download" style="margin-top: 25px;">Download</h3>

                            <b-row style="margin-top: 10px">
                                <b-col cols="3"></b-col>
                                <b-col cols="3">Unannotated</b-col>
                                <b-col cols="3">Unaligned</b-col>
                                <b-col cols="3">Both</b-col>
                            </b-row>

                            <b-row style="margin-top: 10px">
                                <b-col cols="3">Contigs FASTA format</b-col>
                                <b-col cols="3"><b-btn block variant="danger">Unannotated contigs</b-btn></b-col>
                                <b-col cols="3"><b-btn block variant="danger">Unaligned contigs</b-btn></b-col>
                                <b-col cols="3"><b-btn block variant="primary" :href="download_fasta_file()">Both contigs</b-btn></b-col>
                            </b-row>
                            <b-row style="margin-top: 10px">
                                <b-col cols="3">Alignment PSL format</b-col>
                                <b-col cols="3"><b-btn block variant="primary" :href="download_psl_file()">Alignment File</b-btn></b-col>
                                <b-col cols="3"></b-col>
                                <b-col cols="3"></b-col>
                            </b-row>
                            <b-row style="margin-top: 10px">
                                <b-col cols="3">CDS FASTA format</b-col>
                                <b-col cols="3"><b-btn block variant="danger">CDS Unannotated</b-btn></b-col>
                                <b-col cols="3"><b-btn block variant="danger">CDS Unaligned</b-btn></b-col>
                                <b-col cols="3"><b-btn block variant="danger">CDS Both</b-btn></b-col>
                            </b-row>
                            <b-row style="margin-top: 10px; margin-bottom: 150px">
                                <b-col cols="3">Peptides FASTA format</b-col>
                                <b-col cols="3"><b-btn block variant="danger">Pep Unannotated</b-btn></b-col>
                                <b-col cols="3"><b-btn block variant="danger">Pep Unaligned</b-btn></b-col>
                                <b-col cols="3"><b-btn block variant="danger">Pep Both</b-btn></b-col>
                            </b-row>

                        </div>

                    </b-col>
                    <b-col cols="4">
<!--Тут будет мини навигация по названиям -->
                        <div>
                            <b-navbar v-b-scrollspy style="position: fixed;">
                                <b-nav pills vertical>
                                    <b-nav-item href="#summary">Summary</b-nav-item>
                                    <b-nav-item href="#denovo">De novo transcriptome assembly</b-nav-item>
                                    <b-nav-item href="#aligning">Aligning to a reference genome</b-nav-item>
                                    <b-nav-item href="#download">Download</b-nav-item>
                                </b-nav>
                          </b-navbar>
                        </div>
                    </b-col>
                </b-row>

        </div>

    </div>
</template>

<script>
    import axios from 'axios';
    import numeral from 'numeral';
    export default {
        name: "ExpResult",
        data: function() {
            return {
                exp_id: null,
                study_text: null,
                items: null,
                num_page: 0,
                ann: null,
                run_accessions: null,
            }
        },
        mounted() {
            axios.get(`/get/exp/${this.$route.params.id}`)
                .then(response => {
                    this.exp_id = response.data['id'];
                    this.study_text = response.data['study_text'];
                    this.run_accessions = response.data['run_accessions'];
                    this.ann = response.data['ann'];
                })
        },
        computed:{
            instrument_model: function() {
                return this.get_ebi()["instrument_model"];
            },
            sample_title: function () {
                return this.get_ebi()["sample_title"];
            },
            scientific_name: function () {
                return this.get_ebi()["scientific_name"];
            },
            library_strategy: function () {
                return this.get_ebi()["library_strategy"];
            },
            study_title: function () {
                return this.get_ebi()["study_title"];
            },
            construction_protocol: function () {
                return this.get_ebi()["construction_protocol"];
            },
            run_accessions_formated: function () {
                return this.run_accessions.join()
            },
            study_link: function (){
                return this.get_ebi()["secondary_study_accession"];
            },
            library_source: function () {
                return this.get_ebi()["library_source"]
            },
            library_selection: function () {
                return this.get_ebi()["library_selection"];
            },
            tissue_type: function () {
                return this.get_ebi()["tissue_type"];
            },
            library_layout: function () {
                return this.get_ebi()["library_layout"];
            },
            reads_number: function () {
                return this.get_trinity()["reads_number"];
            },
            KMERs: function () {
                return numeral(this.get_trinity()["KMERs"]).format('0,0');
            },
            in_size: function () {
                return `${numeral(this.get_trinity()["in_size"]).format('0,0')}Mb`;
            },
            out_size: function () {
                return `${numeral(this.get_trinity()["out_size"]).format('0,0')}Mb`
            },
            transcripts: function () {
                return this.get_transcripts_count();
            },
            transcripts_percent: function () {
                return this.format_string_counts(this.calc_percent_by_transcripts(this.get_transcripts_count()))
            },
            transcripts_500: function () {
                return this.get_quast()["Transcripts > 500 bp"]
            },
            transcripts_1000: function () {
                return this.get_quast()["Transcripts > 1000 bp"]
            },
            ave_length: function () {
                return this.get_quast()["Average length of assembled transcripts"];
            },
            longest_transcript: function () {
                return this.get_quast()["Longest transcript"];
            },
            total_length: function () {
                return this.get_quast()["Total length"];
            },
            transcript_n50: function () {
                return this.get_quast()["Transcript N50"];
            },
            trinity_version: function () {
                return this.get_trinity()["version"];
            },
            genome_name: function () {
                return this.get_gmap()["cmd"].match(/ -d ([\w.]+)/)[1];
            },
            genes: function () {
                return this.get_quast()["Genes"];
            },
            protein_coding_genes: function () {
                return this.get_quast()["Protein coding genes"];
            },
            isoforms: function () {
                return this.get_quast()["Isoforms"];
            },
            exons: function () {
                return this.get_quast()["Exons"]
            },
            introns: function () {
                return this.get_quast()["Introns"]
            },
            avg_length_of_all_isoforms: function () {
                return this.get_quast()["Avg. length of all isoforms"]
            },
            total_length_of_all_isoforms : function () {
                return this.get_quast()["Total length of all isoforms"];
            },
            avg_exon_length: function () {
                return this.get_quast()["Avg. exon length"]
            },
            avg_intron_length: function () {
                return this.get_quast()["Avg. intron length"]
            },
            avg_number_of_exons_per_isoform: function () {
                return this.get_quast()["Avg. number of exons per isoform"];
            },
            max_number_of_exons_per_isoform: function () {
                return this.get_quast()["Max. number of exons per isoform"];
            },

            aligned: function () {
                return this.format_string_counts(this.calc_percent_by_transcripts(
                    this.get_quast()["Aligned"]));
            },
            uniquely_aligned: function () {
                return this.format_string_counts(this.calc_percent_by_transcripts(
                    this.get_quast()["Uniquely aligned"]));
            },
            multiply_aligned: function () {
                return this.format_string_counts(this.calc_percent_by_transcripts(
                    this.get_quast()["Multiply aligned"]));

            },
            misassembly_candidates: function () {
                return this.format_string_counts(this.calc_percent_by_transcripts(
                    this.get_quast()["Misassembly candidates reported by GMAP (or BLAT)"]));
            },
            unaligned: function () {
                return this.format_string_counts(this.calc_percent_by_transcripts(
                    this.get_quast()["Unaligned"]));
            },
            unannotated: function () {
                return this.format_string_counts(this.calc_percent_by_transcripts(
                    this.get_quast()["Unannotated"]));
            },
            average_aligned_fraction: function () {
                return this.get_quast()["Average aligned fraction"];
            },
            average_alignment_length: function () {
                return this.get_quast()["Average alignment length"];
            },
            average_blocks_per_alignment: function () {
                return this.get_quast()["Average blocks per alignment"];
            },
            average_block_length: function () {
                return this.get_quast()["Average block length"];
            },
            average_mismatches_per_transcript: function () {
                return this.get_quast()["Average mismatches per transcript"];
            },
            na50: function () {
                return this.get_quast()["NA50"];
            }
        },
        methods: {
            get_ebi: function () {
                return this.ann["ebi"];
            },
            get_trinity: function () {
                return this.ann["trinity"];
            },
            get_quast: function () {
                return this.ann["quast"];
            },
            get_gmap: function () {
                return this.ann["gmap"];
            },
            format_string_counts: function (arr) {
                return `${arr[0]} (${arr[1]})`
            },
            calc_percent_by_transcripts: function (value) {
                return [value, numeral(value / this.get_transcripts_count()).format('0.00%')]
            },
            get_transcripts_count: function () {
                return this.get_quast()["Transcripts"]
            },
            download_fasta_file: function () {
                return `/get/exp/${this.$route.params.id}/fasta`
            },
            download_psl_file: function () {
                return `/get/exp/${this.$route.params.id}/psl`
            }

        }

    }

</script>

<style scoped>

</style>